import React from 'react';
import { connect } from 'react-redux';
//Actions
import { startLogout } from '../actions/auth';
import { getAdminPlaces, getPlace } from '../actions/place';
//Components
import Loader from 'locki-dashboard-navigation/dist/loader';
import Main from './Main';
//Material-ui
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  root: {
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
  },
  paper: {
    maxWidth: '400px',
    maxHeight: '400px',
    overflow: 'auto',
    padding: '1rem',
  },
});

class SelectPlace extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      places: [],
    };
  }
  componentDidMount() {
    this.props.getAdminPlaces().then(({ data }) => {
      if (data.length) {
        const state = { places: data ? data : [] };
        data.length === 1
          ? this.handleClick(data[0].id)
          : this.setState(() => state);
      } else {
        alert('No eres administrador');
        this.props.startLogout();
      }
    });
  }
  handleClick = (placeUid) => {
    this.props.getPlace(placeUid);
    //Emty places to display loader
    this.setState(() => {
      return { places: [] };
    });
  };
  render() {
    const { classes, placeName } = this.props;
    const { places } = this.state;
    const list = (
      <Paper className={classes.paper} levation={4} square>
        <List className={classes.list} component="nav">
          {places.map(({ id, name }, i) => {
            return (
              <ListItem button key={i} onClick={() => this.handleClick(id)}>
                <ListItemText primary={name} />
              </ListItem>
            );
          })}
        </List>
      </Paper>
    );
    const select = (
      <div className={classes.root}>
        {places.length > 0 ? list : <Loader />}
      </div>
    );
    return placeName ? <Main /> : select;
  }
}

const mapStateToProps = (state, props) => ({
  placeName: state.place ? state.place.name : '',
});

const mapDispatchToProps = (dispatch) => ({
  getAdminPlaces: (adminUid) => dispatch(getAdminPlaces(adminUid)),
  getPlace: (placeUid) => dispatch(getPlace(placeUid)),
  startLogout: () => dispatch(startLogout),
});

export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps, mapDispatchToProps)(SelectPlace)
);
